import { Loading } from 'nb-vue-element'

let $Loading = {
  queue: new Map(),
  isLoading: false,
  $loadig: null
}
export const getLoading = (config) => {
  const time = +new Date()
  let loadingConfig = {
    background: 'rgba(0, 0, 0, 0.1)',
    target: '.wrapper'
  }
  if (config.loadingTarget) {
    loadingConfig.target = config.loadingTarget
  }
  if (!$Loading.isLoading) {
    config.$loading = time
    $Loading.queue.set(`${config.url}/${time}`, time)
    $Loading.$loadig = Loading.service(loadingConfig)
    $Loading.isLoading = true
  }
  return config
}
export const endLoading = (response) => {
  $Loading.queue.delete(`${response.config.url}/${response.config.$loading}`)
  if ($Loading.isLoading && $Loading.queue.size === 0) {
    $Loading.$loadig && $Loading.$loadig.close()
    $Loading.$loadig = null
    $Loading.isLoading = false
  }
  return response
}
export const errorLoading = () => {
  return $Loading.$loadig && $Loading.$loadig.close()
}
